import { base } from "./base";
import { BASE_CALENDAR_URL } from "./constants";
import { errorToastHook } from "./hooks/errorToast";
import { loaderEndHook, loaderErrorHook, loaderStartHook } from "./hooks/loader";
import { localTokenRefreshHook } from "./hooks/tokenRefresh";
import { makeAuthHook } from "./hooks/auth";

const localAuthHook = makeAuthHook(() => localStorage.getItem("token"));

// Authenticated calendar instance — same as httpAuth2 but targets the calendar base URL
export const httpCalendar2 = base.extend({
  hooks: {
    afterResponse: [loaderEndHook, localTokenRefreshHook],
    beforeError: [loaderErrorHook, errorToastHook],
    beforeRequest: [loaderStartHook, localAuthHook],
  },
  prefix: BASE_CALENDAR_URL,
});
